import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux';
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import ServiceAlertsForm from './ServiceAlertsForm'

class ServiceAlertsModal extends React.Component {

  static propTypes = {
    baseProps: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.number
  }

  handleOk = async (form) => {
    const { baseProps } = this.props
    const { onSave, editingRule } = baseProps || {}

    try {
      // 获取表单值
      const values = await form.current.validateFields()

      // 规则类型：问题预警 / 完成率预警
      const ruleType = values.rule_type || 'alert'

      // 格式化数据（规则模型）
      const formData = {
        rule_type: ruleType,                // alert | completion_rate
        alert_type: values.alert_type,
        alert_level: values.alert_level,
        threshold_type: values.threshold_type,
        threshold_value: values.threshold_value,
        threshold_unit: values.threshold_unit,
        comparison_operator: values.comparison_operator,
        notice_way: values.notice_way,
        notice_object_type: values.notice_object_type,
        notice_objects: values.notice_objects,
        notice_content: values.notice_content,
      }

      // 调用保存回调
      if (onSave) {
        onSave(formData)
      } else {
        // TODO: 调用实际的保存接口
        message.success(editingRule ? '更新成功' : '新增成功')
      }

      return true // 返回 true 关闭弹窗
    } catch (error) {
      console.error('表单验证失败:', error)
      return false // 返回 false 不关闭弹窗
    }
  }

  handleCancel = () => {
    const { baseProps } = this.props
    const { onCancel } = baseProps || {}
    if (onCancel) {
      onCancel()
    }
  }

  render () {
    const { children, baseProps, title } = this.props
    const { editingRule, defaultAlertType } = baseProps || {}
    
    const baseComponent = (
      <ServiceAlertsForm
        editingRule={editingRule}
        defaultAlertType={defaultAlertType}
      />
    )
    
    return (
      <WrappedModal
        children={children}
        baseProps={{ ...baseProps }}
        baseComponent={baseComponent}
        title={title}
        width={900}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        centerTitle
        className={`center-title-modal`}
      />
    )
  }
}
// 使用函数组件作为wrapper来使用React Redux Hooks，然后传递给类组件
const VisualDashboardWrapper = (props) => { // 接收所有props
  const dispatch = useDispatch();
  // 修复数据选择逻辑
  const enhancedProps = {
    dispatch,
    ...props // 传递所有接收到的props，包括children
  }
  return <ServiceAlertsModal {...enhancedProps}/>;
};

export default VisualDashboardWrapper;

